export default "__VITE_ASSET__CLZQ14rc__"